var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src && _vm.animationData)?_c('lottie',{attrs:{"options":Object.assign({}, {animationData: _vm.animationData},
    _vm.options)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }